import myAxios from './myAxios';

export async function getContacts() {
  return myAxios.get('/messenger/contacts/');
}

export default async function createContact(firstName, lastName, userId) {
  const data = {
    user: userId,
    user_first_name: firstName,
    user_last_name: lastName,
  };
  return myAxios.post('/messenger/contacts/', data);
}
